import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import hu from '@/locales/hu.json'

export type Locale = 'en' | 'hu'

/** English is the default interface language; Hungarian is second. */
export function createAppI18n(locale: Locale = 'en') {
  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'en',
    messages: { en, hu },
  })
}
